const GarnishMass=[
    {
        id:1,
        title:"спаржа з шинкою під сиром 250г",
        isNew: true,
        price:"135 грн",
        src: require('../img/spargasvet.png'),
        text:"спаржа, шинка, сир гауда",
    allergy: `🥛молоко (гауда),🌱соя`
    },
    {
        id:2,
        title:"Картопля фрі 130г/30г",
        price:"105 грн",
        src: require('../img/fri.webp'),
        text:"Картопля, кетчуп або майонез на вибір",
    },
    {
        id:3,
        title:"Картопля по-селянськи 130г/30г",
        price:"105 грн",
        src: require('../img/selo.webp'),
        text:"Картопля, часник, зелень, соус тар-тар",
    },
    //{
        //id:4,
        //title:"сковорідка броколі під сиром 200г",
        //price:"119 грн",
        //src: require('../img/skovbrok.webp'),
        //text:"броколі, соєвий соус, сир моцарела",
    //},
    {
        id:5,
        title:"сковорідка спаржа під сиром 200г",
        price:"134 грн",
        src: require('../img/skovorspar.webp'),
        text:"спаржа, соєвий соус, сир гауда",
    allergy: `🥛молоко (гауда),🌱соя`
    },
    {
        id:6,
        title:"овочі гриль 200г",
        price:"124 грн",
        src: require('../img/ovogril.png'),
        text:"кукуруза, помідор, печериці, перець болгарський, соєвий соус",
    allergy: `🍄‍🟫 гриби,🌱соя`
    },

    
]

export default GarnishMass;